import React from "react";
import { DesktopSidebar } from "../navigation/DesktopSidebar";

export function AdminSidebar({
  sections,
  activeSectionId,
  onSelectSection,
  orgName,
  onReturn,
}) {
  return (
    <DesktopSidebar
      sections={sections}
      activeSectionId={activeSectionId}
      onSelectSection={onSelectSection}
      orgName={orgName}
      ariaLabel="Administration sections"
      leadItemId="overview"
      returnLabel="CrewPilot"
      onReturn={onReturn}
    />
  );
}
